import { StylesIndexInjections } from 'common-react';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { CircularSpinnerProps, CircularSpinnerSize } from './tools/CircularSpinner.model';

const spinnerColor = (theme: Theme, inverted: boolean) => {
  if (inverted) return theme.color.greys[0];
  return theme.color.oranges[50];
};

const spinnerSize = (size: CircularSpinnerSize) => {
  switch (size) {
    case 'extraSmall':
      return 16;
    case 'small':
      return 24;
    case 'medium':
      return 32;
    case 'large':
      return 48;
}
}

export default makeUiStyles((theme: Theme) => createStyles({
  '@keyframes spinner-dash': {
    '0%': {
      strokeDasharray: '6, 122',
      strokeDashoffset: 0,
    },
    '50%': {
      strokeDasharray: '100, 28',
      strokeDashoffset: -16,
    },
    '100%': {
      strokeDasharray: '6, 122',
      strokeDashoffset: -127,
    },
  },
  '@keyframes spinner-rotate': {
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  root: {
    width: '100%',
    height: '100%',
    padding: (props: CircularSpinnerProps) => props.disablePadding ? 0 : 24,
    display: 'flex',
    justifyContent: 'center',
  },
  spinner: {
    width: (props: CircularSpinnerProps) => spinnerSize(props.size ?? 'large'),
    height: (props: CircularSpinnerProps) => spinnerSize(props.size ?? 'large'),
    animation: '$spinner-rotate 2s linear infinite',
    fill: 'none',
    '& circle': {
      stroke: (props: CircularSpinnerProps) => spinnerColor(theme, props.inverted ?? false),
      animation: '$spinner-dash 1.35s ease-in-out infinite',
      strokeWidth: (props: CircularSpinnerProps) => props.thickness ?? 4,
    }
  }
}), { name: 'CircularSpinner', index: StylesIndexInjections.UI_ATOMS });
